import { ArrowLeft, FileQuestion } from "lucide-react";
import { Link } from "react-router-dom";
import { Card } from "@/components/ui/Card";

export function NotFoundPage() {
  return (
    <div className="mx-auto flex min-h-[65vh] max-w-xl items-center justify-center px-4">
      <Card className="w-full p-8 text-center sm:p-10">
        <div className="mx-auto flex h-14 w-14 items-center justify-center rounded-2xl bg-surface-muted text-ink-muted"><FileQuestion className="h-7 w-7" /></div>
        <p className="mt-6 text-xs font-bold uppercase tracking-[0.18em] text-brand-700">404</p>
        <h1 className="mt-2 text-3xl font-black text-ink">Page not found</h1>
        <p className="mt-3 text-sm leading-6 text-ink-muted">The page may have moved, or the invoice link may no longer be active.</p>
        <Link to="/app" className="mt-6 inline-flex min-h-11 items-center justify-center gap-2 rounded-xl bg-ink px-5 text-sm font-bold text-white hover:bg-[#26363d]"><ArrowLeft className="h-4 w-4" />Return to dashboard</Link>
      </Card>
    </div>
  );
}
